"use client";

import React from "react";
import { ArrowRight, Star, Heart, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function MeetRameshDevTrustedSpiritualAdvisor() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll();
  return <section data-section-id="39287" id="about-clint-experience" className="bg-background text-foreground py-16 md:py-24 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="w-full">
          <div ref={textRef} className={`flex flex-col gap-6 transition-all duration-1000 ease-out ${isTextVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-10"}`}>
            <div className="space-y-2">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent/10 text-primary text-sm font-semibold w-fit tracking-wide">
                <Sparkles className="w-4 h-4" />
                <span>30+ Years Experience</span>
              </div>
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-sans font-bold tracking-tight text-primary">Behind the Finish</h2>
            </div>

            <div className="space-y-4 text-muted-foreground text-lg leading-relaxed">
              <p>
                With over three decades of mastery in residential and industrial painting, 
                Clint has dedicated his career to perfecting the art of the finish. Based 
                on the Northern Central Coast, he brings a level of local expertise and 
                professional reliability that is unmatched in the region.
              </p>
              <p>
                Clint understands that your property is your most valuable asset. Whether 
                it's a coastal home in Norah Head or an industrial site in Lake Haven, 
                his meticulous preparation and premium finishing techniques guarantee 
                lasting beauty and protection for years to come.
              </p>
            </div>

            <div className="flex flex-wrap gap-6 py-4">
              <div className="flex items-center gap-3">
                <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-secondary/10 text-secondary">
                  <Star className="w-5 h-5" />
                </div>
                <div>
                  <p className="font-bold text-primary">30+ Years</p>
                  <p className="text-sm text-muted-foreground">Experience</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-secondary/10 text-secondary">
                  <Heart className="w-5 h-5" />
                </div>
                <div>
                  <p className="font-bold text-primary">1000+ Projects</p>
                  <p className="text-sm text-muted-foreground">Completed</p>
                </div>
              </div>
            </div>

            <div className="pt-2">
              <Button asChild size="lg" className="rounded-lg px-8 bg-primary text-primary-foreground hover:bg-accent hover:text-accent-foreground transition-colors duration-300">
                <Link to="/ContactPage">
                  Get a Free Quote <ArrowRight className="ml-2 w-4 h-4" />
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}